import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map, Observable, tap } from "rxjs";
import { ContactInfo } from "src/app/models/contact.model";
import { StorageService } from "../services/storage/storage.service";

/**
 * A resolver that sets up the app.
 * @param {StorageService} _storageService - The storage service.
 * @param {Router} _router - The router.
 * @returns None
 */
@Injectable({providedIn: 'root'})
export class AppSetResolver  {
  constructor(private _storageService: StorageService, private _router: Router) {}

  resolve(): Observable<boolean> {
    return this._storageService.setUpApp().pipe(
      map((contact: ContactInfo | false) => !!contact)
    );
  }
}
